__turbopack_context__.v({
  "disclaimer": "CreateWalletFooter-module__zzeD7q__disclaimer",
  "primaryButton": "CreateWalletFooter-module__zzeD7q__primaryButton",
  "root": "CreateWalletFooter-module__zzeD7q__root",
  "secondaryButton": "CreateWalletFooter-module__zzeD7q__secondaryButton",
});
